var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"biotesting_section"}},[_c('BioTestingQuiz')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }